import { cn } from "@/lib/utils";
import { formatPrice } from "@/utils/priceUtils";
import { Paragraph } from "@app/_components/ui";
import { useMarket, useSiteInfo } from "@app/_context";
import { InfoIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { useCheckout, useCheckoutContext } from "./Checkout.hooks";
import CheckoutMessage from "./CheckoutMessage";

export default function CheckoutMinimumOrderNotification({
  className,
  ...props
}: ComponentProps<typeof CheckoutMessage>) {
  const marketConfig = useMarket().state.market;
  const { data: checkout } = useCheckout();
  const { minimumOrderValue } = useSiteInfo();
  const { dictionary } = useCheckoutContext();

  const minOrderValueThreshold =
    minimumOrderValue ?? marketConfig.minimumOrderValue ?? 0;

  const minOrderValueThresholdFormatted = formatPrice(
    minOrderValueThreshold,
    marketConfig.locale,
  );

  if (
    typeof checkout?.totalGrossAmount !== "number" ||
    !dictionary.checkoutMinimumOrderNotification ||
    checkout.purchasableBelowMinimumOrderValue ||
    checkout.totalGrossAmount - checkout.totalFreightInclVat >=
      minOrderValueThreshold
  ) {
    return null;
  }

  return (
    <CheckoutMessage
      className={cn("max-w-lg text-base", className)}
      icon={<InfoIcon size={16} className="shrink-0 translate-y-0.5" />}
      {...props}
    >
      <Paragraph>
        {minOrderValueThresholdFormatted &&
          dictionary.checkoutMinimumOrderNotification && (
            <>
              {dictionary.checkoutMinimumOrderNotification.replace(
                "{value}",
                minOrderValueThresholdFormatted,
              )}
            </>
          )}
      </Paragraph>
    </CheckoutMessage>
  );
}
